import React, { useState } from 'react';
import { CheckboxIconSVG } from 's2s-svg-icons';
import PropTypes from 'prop-types';
import { colorGrid } from 's2s-themes';
import styled from 'styled-components';
import { injectIntl } from 'react-intl';

const Container = styled.div`
  align-items: center;
  border-radius: 2px;
  display: flex;
  flex-direction: ${(props) => props.labelPos === "left" ? 'row' : 'row-reverse'};
  justify-content: ${(props) => props.labelPos === "left" ? 'flex-start' : 'flex-end'};
  padding: 8px 0;
  width: fit-content;
`;

const Input = styled.input`
  position : absolute;
  visibility : hidden;
  height: 24px;
  width: 24px;
  box-sizing : border-box;
`;

const Label = styled.label`
  color: ${props => props.disabled ? colorGrid.gray6 : '#001221'};
  cursor: pointer;
  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
  margin-left : ${ props => props.labelPos === 'right' ? '15px' : '0px'};
  margin-right : ${ props => props.labelPos === 'left' ? '6px' : '0px'}; 
  line-height: 16px;
`;

const CheckboxChecked = styled.div`
  background-color: #243991;
  border : 2px solid ${colorGrid.blue6};
  border-radius : 4px;
  cursor: pointer;
  outline : 0;
  position : relative;
  height: 20px;
  width : 20px;
  box-sizing : border-box;
`;

const CheckboxUnchecked = styled.div`
  background-color: ${colorGrid.gray0};
  border : 1px solid ${colorGrid.gray3};
  border-radius : 4px;
  cursor : pointer;
  outline : 0;
  position : relative;
  width : 20px;
  height: 20px;
  box-sizing : border-box;
  &:focus{
    border: ${'solid 2px ' + colorGrid.blue6};
    position : relative;
  }
`;

const CheckboxDisabled = styled.div`
  background-color: ${colorGrid.gray2};
  border : 1px solid ${colorGrid.gray3};
  border-radius : 4px;
  cursor : not-allowed;
  outline : 0;
  position : relative;
  width : 20px;
  height: 20px;
  box-sizing : border-box;
`;

const CheckSVGUnchecked = styled.div`
  align-items : center;
  display : none;
  left : -2px;
  margin : 0px;
  padding : 0px;
  position : absolute;
  top : -2px;
  height: 20px;
  width : 20px;
`;

const CheckSVGChecked = styled.div`
  align-items : center;
  left : -2px;
  margin : 0px;
  padding : 0px;
  position : absolute;
  top : -2px;
  width : 20px;
  height: 20px;
`;

const Checkbox = (props) => {
  const [isChecked, setChecked] = useState(props.isChecked);

  const toggleCheckBox = () => {
    if (!props.disabled) {
      const newValue = !isChecked;

      setChecked(newValue);

      props.cbChanged && props.cbChanged(newValue);
    }

  };

  const handleKeyDownMenu = (e) => {
    switch (e.keyCode) {
      case 32: //spacebar
        toggleCheckBox();
        break;
      case 13: //enter
        toggleCheckBox();
        break;
      default:
        break;
    }
  };


  const CheckboxState = isChecked ? CheckboxChecked : CheckboxUnchecked;
  const DynamicCheck = props.disabled === true ? CheckboxDisabled : CheckboxState;
  const DynamicSVGContainer = isChecked ? CheckSVGChecked : CheckSVGUnchecked;

  return (
    <Container
      className={"CheckboxContainer " + props.className}
      aria-label="checkbox"
      labelPos={props.labelPos}
    >
      <Label
        className="Label"
        aria-label={props.label}
        htmlFor="checkbox"
        labelPos={props.labelPos}
        onClick={toggleCheckBox}
        disabled={props.disabled}
      >
        {props.label}
      </Label>
      <DynamicCheck
        aria-label="checkbox"
        aria-checked={isChecked}
        className="CheckboxCustom"
        role='checkbox'
        onClick={toggleCheckBox}
        onKeyDown={handleKeyDownMenu}
        tabIndex="0"

      >
        <DynamicSVGContainer className="DynamicSVGContainer" >
          <CheckboxIconSVG
            className="CheckboxIconSVG"
            svgStyle={{
              fill: colorGrid.gray0,
              height: '20px',
              width: '20px'
            }}
          />
        </DynamicSVGContainer>
        <Input
          className="Input"
          aria-label="checkbox"
          defaultChecked={isChecked}

          tabIndex="0"
          type="checkbox"
          disabled={props.disabled}
        />
      </DynamicCheck>

    </Container>
  );

};


export default injectIntl(Checkbox);

Checkbox.propTypes = {
  cbChanged: PropTypes.func,
  disabled: PropTypes.bool,
  isChecked: PropTypes.bool,
  label: PropTypes.string,
  labelPos: PropTypes.oneOf(['left', 'right'])
};

Checkbox.defaultProps = {
  cbChanged: () => { console.log(' Default callback function for cbChanged.'); },
  disabled: false,
  isChecked: false,
  label: undefined,
  labelPos: 'right'
};